import { ToastContainer, ToastContainerProps } from "react-toastify";

import { AlertPopup } from "./alertPopup";
import TlpModal from "./tlpModal";

import "react-toastify/dist/ReactToastify.css";

interface TLPComponentsProps {
	toastContainerProps?: Partial<ToastContainerProps>;
	/** Embedded apps share their host's toast container. */
	showToastContainer?: boolean;
}

export function TLPComponents(props: TLPComponentsProps) {
	const { toastContainerProps, showToastContainer = true } = props;

	return (
		<>
			<TlpModal movable />
			<AlertPopup />
			{showToastContainer && <ToastContainer position="top-right" {...toastContainerProps} />}
		</>
	);
}
